<div class="snackbar-content" (click)="dismiss()">
  <mat-icon class="icon" [ngStyle]="{ color: data.color }">{{ data.icon }}</mat-icon>
  <span class="message">{{ data.message }}</span>
</div>
